import { makeAutoObservable } from 'mobx'

/**
 * class to be used in order to be a drop in replacement for react's Ref, but with observability for when current actually receives a ref
 */
export default class ObservableRef<T> {
   params
   current: T | null

   constructor(params?: { initializer?: T; onSet?: () => any }) {
      this.current = params?.initializer || null
      this.params = params
      makeAutoObservable(this)
   }

   set = (element: T) => {
      this.current = element
      this.params?.onSet && this.params?.onSet()
   }
}
